/**
 * 日程模块
 */
import { PAGE_LEVEL } from '@/constants';
export default {
  meta: {
    localeModules: [
      'schedule',
      'meeting',
      'summary',
      'aiChat',
      'aiChatConstants',
      'cloudDocument',
      'report',
      'research',
      'roadshow',
      'strategy'
    ]
  },
  path: '/scheduleManage',
  redirect: '/scheduleManage/list',
  children: [
    {
      path: '/scheduleManage/list',
      name: 'selfHelpMeeting',
      component: () => import(/* webpackChunkName: 'my-schedule-index' */ '@/pages/scheduleModule/mine/main.vue'),
      meta: {
        name: 'routers.schedule_schedule',
        pageLevel: PAGE_LEVEL.FIRST,
        // 页面组件名称 用于缓存
        componentName: 'ScheduleModuleIndex',
        keepAlive: true
      }
    },
    {
      path: '/scheduleManage/mine/addSchedule',
      name: 'addSchedule',
      component: () => import(/* webpackChunkName: 'add-schedule' */ '@/pages/scheduleManage/mine/add.vue'),
      meta: {
        name: 'routers.schedule_add_schedule',
        pageWidth: '960px',
        // 隐藏导航
        hiddenNav: true,
        single: true,
        parent: '/scheduleManage/list',
        // 其他父级页面
        otherParent: ['/self-help/meeting/list'],
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      path: '/scheduleManage/mine/researchDetail',
      name: 'researchDetail',
      component: () =>
        import(/* webpackChunkName: 'research-detail' */ '@/pages/scheduleManage/mine/researchDetail.vue'),
      meta: {
        name: 'routers.schedule_activity_detail',
        parent: '/scheduleManage/list',
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      path: '/scheduleManage/mine/meetDetail',
      name: 'meetDetail',
      component: () => import(/* webpackChunkName: 'meet-detail' */ '@/pages/scheduleManage/mine/meetDetail.vue'),
      meta: {
        name: 'routers.schedule_meeting_detail',
        pageLevel: PAGE_LEVEL.SECOND,
        parent: '/scheduleManage/list',
        // 其他父级页面
        otherParent: ['/self-help/meeting/list']
      }
    },
    {
      path: '/scheduleManage/mine/roadshowMeeting',
      name: 'roadshowMeeting',
      component: () =>
        import(/* webpackChunkName: 'roadshow-meeting' */ '@/pages/scheduleManage/mine/roadshowMeetingPage.vue'),
      meta: {
        name: 'routers.schedule_summary_detail',
        parent: '/summary/list',
        pageLevel: PAGE_LEVEL.SECOND,
        // hiddenNav: true,
        // electron 下 打开新tab
        electronSingle: true,
        hideOuterBreadcrumb: true,
        allowMenuBack: true,
        dynamicTitle: true
      }
    },
    // 查看纪要(旧)
    {
      path: '/scheduleManage/mine/roadshowMeetingOld',
      name: 'roadshowMeetingOld',
      component: () =>
        import(/* webpackChunkName: 'roadshow-meeting-old' */ '@/pages/scheduleManage/mine/roadshowMeetingPage.vue'),
      meta: {
        name: 'routers.schedule_summary_detail',
        parent: '/scheduleManage/list',
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      path: '/scheduleManage/mine/otherThingsMeetDetail',
      name: 'otherThingsMeetDetail',
      component: () =>
        import(
          /* webpackChunkName: 'other-things-meet-detail' */ '@/pages/scheduleManage/mine/otherThingsMeetDetail.vue'
        ),
      meta: {
        name: 'routers.schedule_schedule_detail',
        parent: '/scheduleManage/list',
        pageLevel: PAGE_LEVEL.SECOND,
        otherParent: ['/globalSearch/index']
      }
    },
    {
      path: '/scheduleManage/mine/editor',
      name: 'importEditor',
      component: () =>
        import(
          /* webpackChunkName: 'import-schedule-edit' */ '@/pages/scheduleManage/companyModule/importSchedule/editor'
        ),
      meta: {
        name: 'routers.schedule_import_schedule',
        pageWidth: '960px',
        parent: '/scheduleManage/list',
        // 隐藏导航
        hiddenNav: true,
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      path: '/scheduleManage/mine/detail',
      name: 'importDetail',
      component: () =>
        import(
          /* webpackChunkName: 'import-schedule-detail' */ '@/pages/scheduleManage/companyModule/importSchedule/detail'
        ),
      meta: {
        name: 'routers.schedule_import_schedule_detail',
        parent: '/scheduleManage/list',
        pageLevel: PAGE_LEVEL.SECOND
      }
    }
  ]
};
